import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { SuccessModalComponent } from 'src/app/work-entry-permit/modals/success-modal/success-modal.component';

@Component({
  standalone: false,
  selector: 'app-create-work-entry-permit',
  templateUrl: './create-work-entry-permit.component.html',
  styleUrls: ['./create-work-entry-permit.component.scss'],
})
export class CreateWorkEntryPermitComponent implements OnInit {
  activeIds: string[] = [];
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  workerNumber: number = 0;

  myForm = new FormGroup({
    name: new FormControl(),
    natureOfWork: new FormControl(),
    startDate: new FormControl(),
    endDate: new FormControl(),
    timeSlot: new FormControl(),
    supervisorName: new FormControl(),
    supervisorEmail: new FormControl(),
    supervisorPhone: new FormControl(),
    locationBuilding: new FormControl(),
    locationFloor: new FormControl(),
    locationUnit: new FormControl(),
    workersList: new FormArray([]),
    markCriticalSwitch: new FormControl(),
  });

  constructor(
    private formBuilder: FormBuilder,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.activeIds = [
      'ngb-panel-0',
      'ngb-panel-1',
      'ngb-panel-2',
      'ngb-panel-3',
      'ngb-panel-4',
      'ngb-panel-5',
      'ngb-panel-6',
      'ngb-panel-7',
      'ngb-panel-8',
      'ngb-panel-9',
      'ngb-panel-10',
    ];

    this.myForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(100)]],
      natureOfWork: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      timeSlot: ['', [Validators.required]],
      supervisorName: ['', [Validators.required]],
      supervisorEmail: ['', [Validators.required]],
      supervisorPhone: ['', [Validators.required]],
      locationBuilding: ['', [Validators.required]],
      locationFloor: ['', [Validators.required]],
      locationUnit: ['', [Validators.required]],
      workersList: this.formBuilder.array([this.newWorker()]),
      markCriticalSwitch: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {}

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  onSubmit(): void {
    console.log(this.myForm.value);

    if (this.myForm.valid) {
      this.openSuccessModal(30356894);
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  openSuccessModal(requestId: number): void {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
    };

    const modalRef = this.modalService.open(
      SuccessModalComponent,
      modalOptions
    );
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.requestId = requestId;

    modalRef.hidden.subscribe(() => {
      this.router.navigate(['/work-entry-permit-details', 1], {
        queryParams: {
          viewOnly: true,
        },
      });
    });
  }

  plus(): void {
    if (this.workerNumber < 3) {
      this.workerNumber++;
    }
  }

  minus(): void {
    if (this.workerNumber > 0) {
      this.workerNumber--;
    }
  }

  workersList(): FormArray {
    return this.myForm.get('workersList') as FormArray;
  }

  newWorker(): FormGroup {
    return this.formBuilder.group({
      workerName: ['', Validators.required],
      workerPhoneNumber: ['', Validators.required],
    });
  }

  addMore(): void {
    this.workersList().push(this.newWorker());
  }

  removeBlock(i: number) {
    this.workersList().removeAt(i);
  }

  clearInput(i: number) {
    this.workersList().at(i).get('workerName')?.reset();
    this.workersList().at(i).get('workerPhoneNumber')?.reset();
  }
}
